function retrieveCrewTimesReadOnly(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/crew-times-read-only`);
}

function updateCrewTimesReadOnly(companyId, crewTimesReadOnly) {
    return window.tenantAxios.patch(`/company/${companyId}/crew-times-read-only`, crewTimesReadOnly);
}

export default {
    retrieveCrewTimesReadOnly,
    updateCrewTimesReadOnly,
};
